export default {
  filterAgrochemicals (agrochemicals, filters) {
    let filteringEntity = agrochemicals
    const {name} = filters
    if (name) {
      filteringEntity = filteringEntity.filter((i) => {
        return !(i.incomeNo.search(new RegExp(name, 'i')) < 0)
      })
    }

    return filteringEntity
  },
  getDependenciesMsg (data) {
    let dependencies = []
    dependencies.push('Las siguientes Ordenes de Trabajo poseen dependencia con el agroquimico que desea eliminar.')
    dependencies.push(' ')
    dependencies.push(...data)
    dependencies.push(' ')
    dependencies.push(' ')
    dependencies.push('Por favor, resuelva las dependencias y vuelva a intentarlo.')
    return dependencies
  }
}
